import { get, post, del } from ".";

export const getElementsDataApi = async (projectId, bimElementId) => {
  if (bimElementId) {
    return await get(`project/${projectId}/model/elements?bimElementId=${bimElementId}`);
  } else {
    return await get(`project/${projectId}/model/elements`);
  }
};

export const getMainModelDataApi = async (projectId) => {
  return await get(`project/${projectId}/model/main-model`);
};

export const getMainModelHistoryApi = async (projectId) => {
  return await get(`project/${projectId}/model/main-model/history`);
};

export const getBackgroundModelUrlApi = async (projectId) => {
  return await get(`project/${projectId}/model/background-model`);
};

export const getBackgroundModelHistoryApi = async (projectId) => {
  return await get(`project/${projectId}/model/background-model/history`);
};

export const updateMainModelApi = async (projectId, workset, params) => {
  return await post(`project/${projectId}/model/new-model?workset=${workset}`, params);
};

export const updateBackgroundModelApi = async (projectId, params, modelId) => {
  const queryString = modelId != null ? `?modelId=${modelId}` : ``;
  return await post(`project/${projectId}/model/new-background-model${queryString}`, params);
};

export const deleteMainModelApi = async (projectId, modelId) => {
  return await del(`project/${projectId}/model/disable-main-model?modelId=${modelId}`);
};

export const deleteBackgroundModelApi = async (projectId, modelId) => {
  return await del(`project/${projectId}/model/disable-background-model?modelId=${modelId}`);
};

export const updateElementApi = async (projectId, params) => {
  return await post(`project/${projectId}/model/update-element`, params);
};

export const getModelSASApi = async (projectId, filename) => {
  return await get(`project/${projectId}/model/sas?filename=${filename}`);
};

export const updateLargeMainModelApi = async (projectId, workset, filename) => {
  return await post(`project/${projectId}/model/new-large-model?workset=${workset}&filename=${filename}`);
};

export const updateLargeBackgroundModelApi = async (projectId, filename, modelId) => {
  let url = `project/${projectId}/model/new-large-background-model?filename=${encodeURIComponent(filename)}`;
  if (modelId != null) {
    url += `&modelId=${encodeURIComponent(modelId)}`;
  }
  return await post(url);
};